import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { ClientAuthService } from './client-auth.service';
import { PORTAL_HOME } from '../../core/auth-redirect';

export const clientAuthGuard: CanActivateFn = (_route, state) => {
  const clientAuthService = inject(ClientAuthService);
  const router = inject(Router);

  if (clientAuthService.isAuthenticated()) {
    return true;
  }

  // Keep the requested destination so deep links survive the login round-trip.
  return router.createUrlTree(['/client/login'], {
    queryParams: { returnUrl: state.url },
  });
};

/**
 * Restricts a route to client admins.
 *
 * Presentation only — every resolver behind these screens re-checks the role
 * against the database, so bypassing this guard yields a page with no data.
 */
export const clientAdminGuard: CanActivateFn = () => {
  const clientAuthService = inject(ClientAuthService);
  const router = inject(Router);

  if (clientAuthService.isClientAdmin()) {
    return true;
  }

  return router.createUrlTree([PORTAL_HOME.client]);
};

/** Keeps an already authenticated client out of the login screen. */
export const clientGuestGuard: CanActivateFn = () => {
  const clientAuthService = inject(ClientAuthService);
  const router = inject(Router);

  if (!clientAuthService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([PORTAL_HOME.client]);
};
